import { RootState } from '..';

export const selectModalInvoiceState = (state: RootState) =>
  state.modalInvoice.modalState;
